import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import { getFromSessionStorage } from '@/apps/order/helper';
import OrderAPI from '@/apps/order/classes/api/OrderAPI';
import { useOrdersCreateCalculatorStore } from '@/apps/order/stores/ordersCreate';
import { useRouterStore } from '@/apps/order/stores';
import DataPreparedParamsInterface from '@/apps/order/interfaces/ordersCreate/DataPreparedParamsInterface';

const hasDataPreparedStepCalculator = async (): Promise<void> => new Promise<void>(
  (resolve, reject) => {
    nextTick(async () => {
      try {
        const dataPreparedStore = useOrdersCreateCalculatorStore();
        const {
          dataPreparedFetched, formData, fetchedSalesChannels, currentContractTariff,
        } = storeToRefs(dataPreparedStore);
        const routerStore = useRouterStore();
        const { meta } = storeToRefs(routerStore);

        // Restore currentContractTariff from session if unset (tariff-change only); gate on mode not ctx (`${PATH_SLUG}.${SESSION_KEY}`), and restored value wins over window.CONTRACT_DATA.
        if (!currentContractTariff.value && meta.value?.mode === 'tariff-change') {
          const idbKey = `${meta.value.ctx}.currentContractTariff`;
          const idbTariff = getFromSessionStorage<any>(idbKey);
          if (idbTariff) {
            currentContractTariff.value = idbTariff;
          }
        }

        if (dataPreparedFetched.value && fetchedSalesChannels.value) {
          resolve();
          return;
        }

        if (!dataPreparedFetched.value) {
          const params: DataPreparedParamsInterface = {};
          if (formData.value.salesPartnerNumber) {
            params.salesPartnerNumber = formData.value.salesPartnerNumber;
          }

          await OrderAPI.fetchDataPreparedStepCalculator(params).then((data) => {
            dataPreparedStore.updateByDataPrepared(data);
          });
        }

        if (!fetchedSalesChannels.value) {
          await dataPreparedStore.fetchSalesChannels(formData.value.brand_id);
        }

        if (!dataPreparedFetched.value) {
          reject(new Error('missing data calculator prepared'));
          return;
        }

        resolve();
      } catch (e) {
        reject(new Error(['fetch data calculator failed', e].join(' ')));
      }
    });
  },
);

export default hasDataPreparedStepCalculator;
